// AUTO-GENERATED from content/classes/jobs.toml — do not edit by hand

import {
  CharacterClass,
  JobClass,
  JobAdvancement,
  CharacterStats,
} from '../../CharacterTypes';

export const JOB_ADVANCEMENTS: Record<JobClass, JobAdvancement> = {
  [JobClass.WARRIOR_BASIC]: {
    job: JobClass.WARRIOR_BASIC,
    name: 'Warrior',
    description: 'Basic warrior class with balanced stats',
    requiredLevel: 1,
    requiredClass: CharacterClass.WARRIOR,
    abilities: [

    ],
    statBonuses: {  },
    color: '#8B4513'
  },
  [JobClass.SWORDSMAN]: {
    job: JobClass.SWORDSMAN,
    name: 'Swordsman',
    description: 'Advanced warrior specializing in sword techniques',
    requiredLevel: 10,
    requiredClass: CharacterClass.WARRIOR,
    abilities: [
      {
        id: 'cleave',
        name: 'Cleave',
        damage: 0,
        manaCost: 25,
        cooldown: 6000,
        lastUsed: 0,
        range: 188,
        castTime: 0,
        description: 'A heavy cleaving swing at the enemy in front of you.',
        icon: '/icons/cleave.svg'
      }
    ],
    statBonuses: { strength: 10, dexterity: 5, attack: 5 },
    color: '#A0522D'
  },
  [JobClass.CRUSADER]: {
    job: JobClass.CRUSADER,
    name: 'Crusader',
    description: 'Holy warrior with defensive capabilities',
    requiredLevel: 30,
    requiredClass: CharacterClass.WARRIOR,
    abilities: [
      {
        id: 'shield_charge',
        name: 'Shield Charge',
        damage: 0,
        manaCost: 15,
        cooldown: 12000,
        lastUsed: 0,
        range: 188,
        castTime: 0,
        description: 'Dash forward behind your shield, strike the enemy you reach, knock it back and stun it briefly.',
        icon: '/icons/shield_charge.svg'
      }
    ],
    statBonuses: { strength: 15, defense: 20 },
    color: '#DAA520'
  },
  [JobClass.HERO]: {
    job: JobClass.HERO,
    name: 'Hero',
    description: 'Master warrior with ultimate techniques',
    requiredLevel: 60,
    requiredClass: CharacterClass.WARRIOR,
    abilities: [
      {
        id: 'raging_blow',
        name: 'Raging Blow',
        damage: 0,
        manaCost: 0,
        cooldown: 8000,
        lastUsed: 0,
        range: 188,
        castTime: 0,
        description: 'A furious strike at the enemy in front of you.',
        icon: '/icons/raging_blow.svg'
      }
    ],
    statBonuses: { strength: 25, attack: 15, criticalRate: 0.1 },
    color: '#FF4500'
  },
  [JobClass.MAGE_BASIC]: {
    job: JobClass.MAGE_BASIC,
    name: 'Mage',
    description: 'Basic mage class with elemental magic',
    requiredLevel: 1,
    requiredClass: CharacterClass.MAGE,
    abilities: [

    ],
    statBonuses: {  },
    color: '#4169E1'
  },
  [JobClass.WIZARD]: {
    job: JobClass.WIZARD,
    name: 'Wizard',
    description: 'Advanced magic user commanding fire and frost',
    requiredLevel: 10,
    requiredClass: CharacterClass.MAGE,
    abilities: [
      {
        id: 'fire_blast',
        name: 'Fire Blast',
        damage: 0,
        manaCost: 15,
        cooldown: 3000,
        lastUsed: 0,
        range: 1000,
        castTime: 0,
        description: 'Hurl a fast blast of fire at your target.',
        icon: '/icons/fire_blast.svg'
      }
    ],
    statBonuses: { intelligence: 10, luck: 8, attack: 8 },
    color: '#4B0082'
  },
  [JobClass.ARCHMAGE]: {
    job: JobClass.ARCHMAGE,
    name: 'Archmage',
    description: 'Master of destructive cosmic spells',
    requiredLevel: 30,
    requiredClass: CharacterClass.MAGE,
    abilities: [
      {
        id: 'meteor_shower',
        name: 'Meteor Shower',
        damage: 0,
        manaCost: 60,
        cooldown: 30000,
        lastUsed: 0,
        range: 1000,
        castTime: 0,
        description: 'Rain meteors around you while you channel, striking enemies where they fall.',
        icon: '/icons/meteor_shower.svg'
      }
    ],
    statBonuses: { intelligence: 20, luck: 15, attack: 15 },
    color: '#8A2BE2'
  },
  [JobClass.RANGER_BASIC]: {
    job: JobClass.RANGER_BASIC,
    name: 'Ranger',
    description: 'Basic archer class with sharp marksmanship',
    requiredLevel: 1,
    requiredClass: CharacterClass.HUNTER,
    abilities: [

    ],
    statBonuses: {  },
    color: '#228B22'
  },
  [JobClass.HUNTER]: {
    job: JobClass.HUNTER,
    name: 'Hunter',
    description: 'Advanced ranger specializing in tracking and traps',
    requiredLevel: 10,
    requiredClass: CharacterClass.HUNTER,
    abilities: [
      {
        id: 'concussive_shot',
        name: 'Concussive Shot',
        damage: 0,
        manaCost: 15,
        cooldown: 5000,
        lastUsed: 0,
        range: 1063,
        castTime: 0,
        description: 'A dazing shot that slows your target.',
        icon: '/icons/concussive_shot.svg'
      }
    ],
    statBonuses: { dexterity: 10, attack: 7, criticalRate: 0.08 },
    color: '#2E8B57'
  },
  [JobClass.RANGER_LORD]: {
    job: JobClass.RANGER_LORD,
    name: 'Ranger Lord',
    description: 'Master marksman commanding long-range devastation',
    requiredLevel: 30,
    requiredClass: CharacterClass.HUNTER,
    abilities: [
      {
        id: 'sniper_shot',
        name: 'Sniper Shot',
        damage: 0,
        manaCost: 35,
        cooldown: 15000,
        lastUsed: 0,
        range: 1063,
        castTime: 0,
        description: 'Take careful aim, then fire a devastating long-range arrow.',
        icon: '/icons/sniper_shot.svg'
      }
    ],
    statBonuses: { dexterity: 20, attack: 15, criticalRate: 0.15 },
    color: '#006400'
  },
  [JobClass.PALADIN_BASIC]: {
    job: JobClass.PALADIN_BASIC,
    name: 'Paladin',
    description: 'Basic holy knight combining martial prowess with divine light',
    requiredLevel: 1,
    requiredClass: CharacterClass.PALADIN,
    abilities: [

    ],
    statBonuses: {  },
    color: '#4682B4'
  },
  [JobClass.KNIGHT]: {
    job: JobClass.KNIGHT,
    name: 'Knight',
    description: 'Advanced paladin with fortified defense',
    requiredLevel: 10,
    requiredClass: CharacterClass.PALADIN,
    abilities: [
      {
        id: 'shield_of_the_righteous',
        name: 'Shield of the Righteous',
        damage: 0,
        manaCost: 30,
        cooldown: 8000,
        lastUsed: 0,
        range: 188,
        castTime: 0,
        description: 'Slam your shield into the enemy in front of you, then stand firmer and take less damage for a short time.',
        icon: '/icons/shield_of_the_righteous.svg'
      }
    ],
    statBonuses: { strength: 5, defense: 20 },
    color: '#1E90FF'
  },
  [JobClass.PALADIN_LORD]: {
    job: JobClass.PALADIN_LORD,
    name: 'Paladin Lord',
    description: 'Divine defender wielding the judgment of the heavens',
    requiredLevel: 30,
    requiredClass: CharacterClass.PALADIN,
    abilities: [
      {
        id: 'judgment',
        name: 'Judgment',
        damage: 0,
        manaCost: 25,
        cooldown: 8000,
        lastUsed: 0,
        range: 188,
        castTime: 0,
        description: 'Strike the enemy in front of you with holy judgment, lowering its defense for a while.',
        icon: '/icons/judgment.svg'
      }
    ],
    statBonuses: { strength: 15, luck: 10, defense: 30 },
    color: '#0000CD'
  },
  [JobClass.THIEF]: {
    job: JobClass.THIEF,
    name: 'Thief',
    description: 'Basic rogue operating from the shadows',
    requiredLevel: 10,
    requiredClass: CharacterClass.ROGUE,
    abilities: [
      {
        id: 'lucky_seven',
        name: 'Lucky Seven',
        damage: 0,
        manaCost: 40,
        cooldown: 12000,
        lastUsed: 0,
        range: 600,
        castTime: 0,
        description: 'Seven stars circle you, then fly at your target one after another.',
        icon: '/icons/lucky_seven.svg'
      }
    ],
    statBonuses: { dexterity: 5, intelligence: 3 },
    color: '#483D8B'
  },
  [JobClass.ASSASSIN]: {
    job: JobClass.ASSASSIN,
    name: 'Assassin',
    description: 'Deadly executioner specializing in swift strikes',
    requiredLevel: 30,
    requiredClass: CharacterClass.ROGUE,
    abilities: [
      {
        id: 'blade_fury',
        name: 'Blade Fury',
        damage: 0,
        manaCost: 25,
        cooldown: 8000,
        lastUsed: 0,
        range: 188,
        castTime: 0,
        description: 'Spin your blades around you, striking every enemy nearby in quick succession.',
        icon: '/icons/blade_fury.svg'
      }
    ],
    statBonuses: { dexterity: 10, attack: 5, criticalRate: 0.1 },
    color: '#2F4F4F'
  },
  [JobClass.HERMIT]: {
    job: JobClass.HERMIT,
    name: 'Hermit',
    description: 'Shadow master elusive in combat',
    requiredLevel: 70,
    requiredClass: CharacterClass.ROGUE,
    abilities: [
      {
        id: 'shadow_step',
        name: 'Shadow Step',
        damage: 0,
        manaCost: 10,
        cooldown: 8000,
        lastUsed: 0,
        range: 100,
        castTime: 0,
        description: 'Dash forward through the shadows.',
        icon: '/icons/shadow_step.svg'
      }
    ],
    statBonuses: { dexterity: 20, attack: 10, criticalRate: 0.15 },
    color: '#1C1C1C'
  },
  [JobClass.NIGHT_LORD]: {
    job: JobClass.NIGHT_LORD,
    name: 'Night Lord',
    description: 'Legendary assassin dominating the darkness',
    requiredLevel: 120,
    requiredClass: CharacterClass.ROGUE,
    abilities: [
      {
        id: 'shadow_blades',
        name: 'Shadow Blades',
        damage: 0,
        manaCost: 0,
        cooldown: 120000,
        lastUsed: 0,
        range: 100,
        castTime: 0,
        description: 'Charge your weapons with shadow: you hit harder and move a little faster for a while.',
        icon: '/icons/shadow_blades.svg'
      }
    ],
    statBonuses: { dexterity: 30, attack: 20, criticalRate: 0.2 },
    color: '#000000'
  },
  [JobClass.SHAMAN_BASIC]: {
    job: JobClass.SHAMAN_BASIC,
    name: 'Shaman',
    description: 'Basic conduit of elemental spirits',
    requiredLevel: 1,
    requiredClass: CharacterClass.SHAMAN,
    abilities: [

    ],
    statBonuses: {  },
    color: '#20B2AA'
  },
  [JobClass.ELEMENTALIST]: {
    job: JobClass.ELEMENTALIST,
    name: 'Elementalist',
    description: 'Master of chain elemental surges',
    requiredLevel: 10,
    requiredClass: CharacterClass.SHAMAN,
    abilities: [
      {
        id: 'shaman_chain_lightning',
        name: 'Chain Lightning',
        damage: 0,
        manaCost: 25,
        cooldown: 6000,
        lastUsed: 0,
        range: 750,
        castTime: 0,
        description: 'Gather the storm, then hurl lightning at your target.',
        icon: '/icons/shaman_chain_lightning.svg'
      }
    ],
    statBonuses: { strength: 5, intelligence: 10, magicAttack: 8 },
    color: '#008B8B'
  },
  [JobClass.SPIRIT_WALKER]: {
    job: JobClass.SPIRIT_WALKER,
    name: 'Spirit Walker',
    description: 'Spiritual guide empowering allies with primal fervor',
    requiredLevel: 30,
    requiredClass: CharacterClass.SHAMAN,
    abilities: [
      {
        id: 'spirit_walk',
        name: 'Spirit Walk',
        damage: 0,
        manaCost: 0,
        cooldown: 0,
        lastUsed: 0,
        range: 100,
        castTime: 0,
        description: 'Passive: the spirits keep you light on your feet.',
        icon: '/icons/spirit_walk.svg'
      }
    ],
    statBonuses: { intelligence: 20, magicAttack: 15, defense: 10 },
    color: '#008080'
  },
  [JobClass.SHAMAN_LORD]: {
    job: JobClass.SHAMAN_LORD,
    name: 'Shaman Lord',
    description: 'Supreme avatar of storms and elemental wrath',
    requiredLevel: 60,
    requiredClass: CharacterClass.SHAMAN,
    abilities: [
      {
        id: 'elemental_mastery',
        name: 'Elemental Mastery',
        damage: 0,
        manaCost: 0,
        cooldown: 0,
        lastUsed: 0,
        range: 100,
        castTime: 0,
        description: 'Passive: your command of the elements makes your attacks stronger.',
        icon: '/icons/elemental_mastery.svg'
      }
    ],
    statBonuses: { strength: 20, intelligence: 25, attack: 15, magicAttack: 20 },
    color: '#004D40'
  }
};

export function getJobAdvancement(characterClass: CharacterClass, level: number): JobClass {
  const baseJob = `${characterClass}_basic` as JobClass;

  if (level >= 60 && characterClass === CharacterClass.WARRIOR) return JobClass.HERO;
  if (level >= 30 && characterClass === CharacterClass.WARRIOR) return JobClass.CRUSADER;
  if (level >= 10 && characterClass === CharacterClass.WARRIOR) return JobClass.SWORDSMAN;

  if (level >= 30 && characterClass === CharacterClass.MAGE) return JobClass.ARCHMAGE;
  if (level >= 10 && characterClass === CharacterClass.MAGE) return JobClass.WIZARD;

  if (level >= 30 && characterClass === CharacterClass.HUNTER) return JobClass.RANGER_LORD;
  if (level >= 10 && characterClass === CharacterClass.HUNTER) return JobClass.HUNTER;

  if (level >= 30 && characterClass === CharacterClass.PALADIN) return JobClass.PALADIN_LORD;
  if (level >= 10 && characterClass === CharacterClass.PALADIN) return JobClass.KNIGHT;

  if (level >= 70 && characterClass === CharacterClass.ROGUE) return JobClass.HERMIT;
  if (level >= 30 && characterClass === CharacterClass.ROGUE) return JobClass.ASSASSIN;
  if (level >= 10 && characterClass === CharacterClass.ROGUE) return JobClass.THIEF;

  if (level >= 60 && characterClass === CharacterClass.SHAMAN) return JobClass.SHAMAN_LORD;
  if (level >= 30 && characterClass === CharacterClass.SHAMAN) return JobClass.SPIRIT_WALKER;
  if (level >= 10 && characterClass === CharacterClass.SHAMAN) return JobClass.ELEMENTALIST;

  return baseJob;
}

export function getJobStatBonuses(jobId?: string): Partial<CharacterStats> {
  if (!jobId) return {};
  const adv = (JOB_ADVANCEMENTS as Record<string, JobAdvancement>)[jobId];
  return adv?.statBonuses ?? {};
}

export function getJobAbilityIds(jobId?: string): string[] {
  if (!jobId) return [];
  const adv = (JOB_ADVANCEMENTS as Record<string, JobAdvancement>)[jobId];
  return adv?.abilities.map((a: any) => a.id) ?? [];
}
